export class IContentManager {
    category: string;
    date: string;
    field: string;
    linea_negocio: string;
    name: string;
    secondary_text: string;
    text: string;
    text_html: string;
    url: string;
}
